import { Box, Typography, capitalize } from "@mui/material"
import { useNavigate, useSearch } from "@tanstack/react-router"
import type { FC } from "react"
import React from "react"

import { FilterChip } from "@/components/common/Filters"
import type { InstructionQueryableFields } from "@/graphql/codegen/graphql"
import { InstructionStatus } from "@/screens/ManageProducts/components/Instructions/types"

const InstructionFilterChips: FC = () => {
  const { isActive, field, order } = useSearch({
    from: "/app/admin/manage-products/_layout/instructions",
    strict: true,
  })
  const navigate = useNavigate({ from: "/app/admin/manage-products/instructions" })

  if (isActive === undefined) {
    return null
  }

  const status = isActive ? InstructionStatus.Active : InstructionStatus.Inactive
  const label = capitalize(status.toLowerCase())

  const handleClearFilter = (key: keyof InstructionQueryableFields) => {
    navigate({
      search: (prev: Record<string, any>) => ({
        ...prev,
        field,
        order,
        [key]: undefined,
      }),
      replace: true,
    })
  }

  return (
    <Box data-testid='instruction-filter-chips' display='flex' flexWrap='wrap' alignItems='center' gap={2}>
      <Typography variant='body1' className='text-gray-700'>
        Applied filters:
      </Typography>
      <FilterChip key={`isActive-${isActive}`} label={label} onDelete={() => handleClearFilter("isActive")} />
    </Box>
  )
}

export default InstructionFilterChips
